import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axiosInstance from '../api/AxiosInstance';
import { endpoints } from '../services/endpoints';
import { showErrorToast, showSuccessToast } from '../helpers/SweetAlert';

const ForgotPassword = () => {
    const navigate = useNavigate();
    const [step, setStep] = useState('email');
    const [email, setEmail] = useState('');
    const [otp, setOtp] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSendOtp = async (event) => {
        event.preventDefault();
        if (!email.trim()) {
            showErrorToast('Email is required');
            return;
        }

        setLoading(true);
        try {
            const resp = await axiosInstance.post(endpoints.forgotPassword, { email });
            showSuccessToast(resp?.data?.message || 'OTP sent to your email');
            setStep('reset');
        } catch (error) {
            showErrorToast(error?.response?.data?.message || 'Failed to send OTP');
        } finally {
            setLoading(false);
        }
    };

    const handleResetPassword = async (event) => {
        event.preventDefault();
        if (!otp.trim() || !newPassword.trim()) {
            showErrorToast('OTP and new password are required');
            return;
        }
        if (newPassword.length < 8) {
            showErrorToast('Password must be at least 8 characters long');
            return;
        }
        if (newPassword !== confirmPassword) {
            showErrorToast('Passwords do not match');
            return;
        }

        setLoading(true);
        try {
            const resp = await axiosInstance.post(endpoints.resetPassword, { email, otp, newPassword });
            showSuccessToast(resp?.data?.message || 'Password updated successfully');
            navigate('/');
        } catch (error) {
            showErrorToast(error?.response?.data?.message || 'Failed to update password');
        } finally {
            setLoading(false);
        }
    };

    return (
        <section className="login-section">
            <div className="container-fluid g-0">
                <div className="row justify-content-center g-0">
                    <div className="col-md-7">
                        <div className="login-main-blk">
                            <div className="login-logo">
                                <Link to="/">
                                    <img src="/assets/images/Logo_transparent.png" alt="Matchmate" />
                                </Link>
                            </div>
                            <div className="login-form-blk">
                                <h1>Forgot password</h1>
                                <p>{step === 'email' ? 'Enter your admin email to receive an OTP' : 'Enter the OTP and your new password'}</p>

                                {step === 'email' ? (
                                    <form onSubmit={handleSendOtp}>
                                        <div className="form-group position-relative">
                                            <label htmlFor="forgot-email" className="form-label">Email</label>
                                            <input
                                                type="email"
                                                className="form-control"
                                                id="forgot-email"
                                                placeholder="Enter your email address"
                                                value={email}
                                                onChange={(event) => setEmail(event.target.value)}
                                            />
                                        </div>
                                        <div className="login-btn-blk">
                                            <button type="submit" className="btn primary-btn" disabled={loading}>
                                                {loading ? 'Sending...' : 'Send OTP'}
                                            </button>
                                        </div>
                                    </form>
                                ) : (
                                    <form onSubmit={handleResetPassword}>
                                        <div className="form-group position-relative">
                                            <label htmlFor="otp" className="form-label">OTP</label>
                                            <input
                                                className="form-control"
                                                id="otp"
                                                placeholder="Enter OTP"
                                                value={otp}
                                                onChange={(event) => setOtp(event.target.value)}
                                            />
                                        </div>
                                        <div className="form-group position-relative">
                                            <label htmlFor="new-password" className="form-label">New Password</label>
                                            <input
                                                className="form-control"
                                                id="new-password"
                                                type="password"
                                                placeholder="Enter new password"
                                                value={newPassword}
                                                onChange={(event) => setNewPassword(event.target.value)}
                                            />
                                        </div>
                                        <div className="form-group position-relative">
                                            <label htmlFor="confirm-password" className="form-label">Confirm Password</label>
                                            <input
                                                className="form-control"
                                                id="confirm-password"
                                                type="password"
                                                placeholder="Confirm new password"
                                                value={confirmPassword}
                                                onChange={(event) => setConfirmPassword(event.target.value)}
                                            />
                                        </div>
                                        <div className="forgot_password">
                                            <button className="link-button" type="button" onClick={() => setStep('email')}>Change email</button>
                                        </div>
                                        <div className="login-btn-blk">
                                            <button type="submit" className="btn primary-btn" disabled={loading}>
                                                {loading ? 'Updating...' : 'Update Password'}
                                            </button>
                                        </div>
                                    </form>
                                )}

                                <div className="text-center mt-3">
                                    <Link to="/">Back to login</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ForgotPassword;
